import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { AnimatedSection } from '../shared/AnimatedSection';
const PREVIEW_IMAGE = 'https://cdn.shopify.com/s/files/1/0661/3847/2542/files/MOOOKUP.png?v=1779559130';
const GOLD = '#C9A84C';
const GOLD_LIGHT = '#E8D48B';
const BENEFITS = ['Descubre tu Reino dominante', 'Accede a archivos y experiencias exclusivas', 'Explora tu Portal privado del Reino', 'Vive una experiencia inmersiva personalizada'];
export function ExperiencePreview() {
  return <section className="relative w-full py-24 md:py-32 px-5 md:px-6 overflow-hidden bg-cosmic-black pt-[55px] pb-[55px]" data-id="element-180">
      {/* Atmospheric backdrop */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-181">
        <div className="absolute inset-0" style={{
        background: `radial-gradient(ellipse at 50% 20%, ${GOLD}14 0%, transparent 60%)`
      }} data-id="element-182" />
        <div className="absolute inset-0" style={{
        background: 'linear-gradient(180deg, #050508 0%, rgba(5,5,8,0.4) 50%, #050508 100%)'
      }} data-id="element-183" />
      </div>

      <div className="relative z-10 container mx-auto max-w-6xl text-center" data-id="element-184">
        <AnimatedSection data-id="element-185">
          {/* Eyebrow badge */}
          <motion.div className="inline-flex items-center px-4 py-2.5 rounded-full mb-6 backdrop-blur-sm" style={{
          background: 'rgba(255,255,255,0.02)',
          border: `1px solid ${GOLD_LIGHT}59`,
          boxShadow: `0 0 18px ${GOLD}25`
        }} initial={{
          opacity: 0,
          y: 8
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-186">
            <span className="text-[10px] md:text-[11px] tracking-[0.3em] uppercase font-serif font-semibold" style={{
            color: GOLD_LIGHT,
            textShadow: `0 0 10px ${GOLD_LIGHT}60`
          }} data-id="element-187">
              Disponible en la Experiencia Completa
            </span>
          </motion.div>

          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white mb-5 md:mb-6 leading-tight max-w-4xl mx-auto" style={{
          textShadow: `0 0 30px ${GOLD}30, 0 4px 30px rgba(0,0,0,0.7)`
        }} data-id="element-188">
            Así comienza tu viaje dentro del Reino
          </h2>

          <p className="max-w-2xl mx-auto text-base md:text-lg lg:text-xl italic leading-relaxed mb-12 md:mb-16 px-2 font-['DM_Sans',_sans-serif]" style={{
          color: 'rgba(203,185,139,0.95)'
        }} data-id="element-189">
            Accede a tu Portal privado, desbloquea tu Reino y explora una
            experiencia única diseñada alrededor de tu identidad emocional.
          </p>
        </AnimatedSection>

        {/* Mockup image */}
        <AnimatedSection delay={0.15} data-id="element-190">
          <motion.div className="relative w-full flex justify-center mb-12 md:mb-14" whileHover={{
          y: -4
        }} transition={{
          type: 'spring',
          stiffness: 200,
          damping: 22
        }} data-id="element-191">
            {/* Glow halo behind the mockup */}
            <div className="absolute inset-x-0 top-1/2 -translate-y-1/2 mx-auto pointer-events-none" style={{
            width: '70%',
            height: '60%',
            background: `radial-gradient(ellipse at center, ${GOLD_LIGHT}25 0%, transparent 70%)`,
            filter: 'blur(40px)'
          }} data-id="element-192" />

            <img src={PREVIEW_IMAGE} alt="Vista previa de la experiencia LOS 12 dentro del Portal del Reino" className="relative w-full md:w-[82%] rounded-2xl md:rounded-3xl transition-all duration-500" style={{
            border: `1px solid ${GOLD_LIGHT}26`,
            boxShadow: `0 0 60px ${GOLD_LIGHT}14, 0 30px 80px rgba(0,0,0,0.65)`
          }} loading="lazy" data-id="element-193" />
          </motion.div>
        </AnimatedSection>

        {/* Benefits chips */}
        <AnimatedSection delay={0.3} data-id="element-194">
          <div className="flex flex-col md:flex-row md:flex-wrap md:justify-center gap-3 md:gap-4 max-w-4xl mx-auto mb-6 md:mb-8" data-id="element-195">
            {BENEFITS.map((benefit, i) => <motion.div key={benefit} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1 + i * 0.07,
            duration: 0.5
          }} className="flex items-center gap-3 px-4 py-3 md:px-5 md:py-3.5 rounded-xl backdrop-blur-sm" style={{
            background: 'rgba(255,255,255,0.02)',
            border: `1px solid ${GOLD_LIGHT}20`
          }} data-id="element-196">
                <span className="text-base md:text-lg flex-shrink-0" style={{
              color: GOLD,
              textShadow: `0 0 8px ${GOLD}80`
            }} data-id="element-197">
                  ✔
                </span>
                <span className="text-sm md:text-base text-white text-left leading-snug font-['DM_Sans',_sans-serif]" data-id="element-198">
                  {benefit}
                </span>
              </motion.div>)}
          </div>

          <p className="md:text-sm italic px-4 font-['DM_Sans',_sans-serif] text-[#D4AF37] text-[15px]" style={{
          opacity: 0.9
        }} data-id="element-199">
            Estas funciones forman parte de la Experiencia Completa del Reino.
          </p>
        </AnimatedSection>
      </div>
    </section>;
}